import React, { type MouseEvent } from 'react';
import noop from 'lodash/noop';
import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import { IconButton } from '@atlaskit/button/new';
import AddIcon from '@atlaskit/icon/core/migration/add';

type Props = {
	label: string;
	onClick?: (e: MouseEvent<HTMLElement>, analyticsEvent: UIAnalyticsEvent) => void;
};

export default function SquareAddIconButton(props: Props) {
	const { label, onClick } = props;
	return (
		<div>
			<IconButton
				testId={`issue-view-common-views.button.icon-button.${label}`}
				appearance="subtle"
				spacing="compact"
				icon={(iconProps) => <AddIcon {...iconProps} color="currentColor" LEGACY_size="small" />}
				label={label}
				onClick={onClick}
				interactionName="auto-generated.jira-issue-view-common-views.button.button"
			/>
		</div>
	);
}

SquareAddIconButton.defaultProps = {
	onClick: noop,
};
